<div
class="floating-widget"
  [ngClass]="{ 'dragging': isDragging }"
  [ngStyle]="{ 'top.px': position.top, 'right.px': position.right }"
  (mousedown)="onMouseDown($event)"
  (touchstart)="onTouchStart($event)">

  <div class="widgets-container">
    <app-start-demo-widget
      *ngIf="(canShowStartTutorialWidget$ | async) && !isDemoDialogOpen && (isScreenWideEnoughForTour$ | async)"
      (dialogOpened)="onDemoDialogOpened()"
      (dialogClosed)="onDemoDialogClosed()"
      [label]="((canShowPaidWidget$ | async) ? 'common.finishSetup.label' : 'common.takeTour.label') | translate | uppercase"
      data-html2canvas-ignore
      class="widget-item">
    </app-start-demo-widget>

    <app-book-call-widget
      *ngIf="(canShowBookCallWidget$ | async) && !isDemoDialogOpen"
      [label]="'common.bookCall.label' | translate | uppercase"
      data-html2canvas-ignore
      class="widget-item">
    </app-book-call-widget>
  </div>


</div>
